import * as $ from 'jquery';

export default class ApplicationTipController {
  private readonly moreButtonSelector = '.js-moreButton';
  private applicationTipController = document.querySelectorAll(this.moreButtonSelector);

  constructor() {
    this.applicationTipController?.forEach(el => el.addEventListener('click', this.openApplicationTip));
  }

  openApplicationTip(event) {
    const clickedElement = event.currentTarget.parentNode;
    const accordions = document.querySelectorAll('.js-targetAudienceItem');
    accordions.forEach(elem => {
      if (elem instanceof HTMLElement) {
        if (elem.classList.contains('applicationTip__open')) {
          elem.classList.remove('applicationTip__open');
        } else if (elem === clickedElement) {
          elem.classList.add('applicationTip__open');
        }
      }
    });
  }

}
